<script>
	import Alert from './componentes/Alert.svelte';
	import ModuloPago from './componentes/ModuloPago.svelte';
	import { iduser, sucursal, urlapp, miPermiso } from './stores/store.js';
	import ModalPago from './componentes/ModalPago.svelte';
	import Modal from './components/Modal.svelte';
	import Carrito from './components/CarritoLotes.svelte';
	import Totales from './components/Totales.svelte';

	import Datoslote from './componentes/Datoslote.svelte';

	import AnimationContainer from './components/AnimationContainer.svelte';
    import { moneda, object2array, postData } from "./scripts";
    import { push } from "svelte-spa-router";
    //import {breakpoint, platform} from './MediaQuery.svelte'
    import { login, prefix, urlapi, viewsXpages } from './stores/store';
    import moment from 'moment'
    import { breakpoint } from './componentes/MediaQuery.svelte';
    import Input from './componentes/Forms/Input.svelte';

    let carritoObj=false;

    /* PERMISOS */
    let viewPage=false;

    let existecia_ignorar=false;
    let aplicar_descuento=false;

    if($login===false)
    {
        push('/login')
    } else if($miPermiso.facturacion.insert===false) {
        push('/sinpermiso')
    } else {
        postData($urlapi, [{ 'cmd':'globales_getOptions' }])
            .then(data => {
                existecia_ignorar=data[0].result.existecia_ignorar;
                aplicar_descuento=data[0].result.aplicar_descuento;
                viewPage=true;
        });
    }

    /* FIN PERMISOS */
    
    let hoy=new Date().toISOString().substring(0, 10);
    let lotes={activo:true,fechacompra:hoy,referencia:'',proveedor:'',observaciones:''};
    //let lotes={activo:false,fechacompra:hoy,referencia:'NREF-3456',proveedor:'PRUEBAS PROVEEDOR',observaciones:'PRUEBA DE OBSERVACIONES DEL LOTE'};


    let cliente={activo:true,nit:'',nombre:'',direccion:'',tipo_cliente:'M'};
    let carrito=[]

/*    carrito=[
        { codigo:'10000001',descripcion:'PIEZA DE HOMBRE', cantidad:2,precio:10.30,descuento:20.1,total:20.60,selected:false,lock:true,encontrado:true},
        { codigo:'30000001',descripcion:'PIEZA DE NIÑOS', cantidad:3,precio:27.43,descuento:0,total:54.86,selected:false,lock:true,encontrado:true},
        { codigo:'20000001',descripcion:'ACCESORIO DAMA', cantidad:2,precio:60.00,descuento:0,total:0,selected:false,lock:true,encontrado:true},
    ]    */

    // COMENTAR DESPUES
    //cliente={activo:false,nit:'65856686',nombre:'GRUPO WEB PUBLICIDAD, S.A.',direccion:'GUATEMALA, CIUDAD'};
    
    /*let carrito=[
        { codigo:'10000001',descripcion:'PIEZA DE HOMBRE', cantidad:2,precio:10.30,descuento:0,total:20.60,selected:false,lock:true,encontrado:true},
    ]*/   
    
    //let cliente={activo:false,nit:'36600792',nombre:'CHRISTIAN LAPUENTE',direccion:'GUATEMALA, CIUDAD',tipo_cliente:'M'};

/*    carrito=[
        { codigo:'10000001',descripcion:'PIEZA DE HOMBRE', cantidad:2,precio:10.30,descuento:20.1,total:20.60,selected:false,lock:true,encontrado:true},
        { codigo:'30000001',descripcion:'PIEZA DE NIÑOS', cantidad:2,precio:27.43,descuento:0,total:54.86,selected:false,lock:true,encontrado:true},
        { codigo:'10000001',descripcion:'PIEZA DE HOMBRE', cantidad:2,precio:10.30,descuento:0,total:0,selected:false,lock:true,encontrado:true},
        { codigo:'20000001',descripcion:'ACCESORIO DAMA', cantidad:2,precio:60.00,descuento:0,total:0,selected:false,lock:true,encontrado:true},
        { codigo:'30000001',descripcion:'ACCESORIO DE NIÑO', cantidad:6,precio:50.00,descuento:0,total:0,selected:false,lock:true,encontrado:true},
    ]*/
    
    /*let carrito=[
        { codigo:'10000001',descripcion:'PIEZA DE HOMBRE', cantidad:1,precio:10.30,descuento:0,total:30.90,selected:false,lock:true,encontrado:true},
        { codigo:'',descripcion:'PRODUCTO NO ASIGNADO', cantidad:0,precio:0,descuento:0,total:0,selected:false,lock:false,encontrado:false},
    ]*/

    let factura={total:0, descuento:0, cantidad:0, noverificarexistencias:false, carrito:carrito, pagado:false,formaPago:false,efectivo:'',efectivo_real:0,tarjeta:''};
    let firmarModal=false;

    let firma={fecha: '',serie: '',numero: '',autorizacion: '',cantidad: 0,total: 0}

    let firma_disponible=false;

    $: if(lotes)
    {
        let countProductos = factura.carrito.filter(function(item){
                if (item.encontrado === true) {
                    return true;
                } else {
                    return false;
                }
            }).length;

        if(lotes.activo===false && countProductos>0) { // linea buena
            firma_disponible=true;    
        } else {
            firma_disponible=false;
        }
    }

    let cancelarFactura=function () {
        setTimeout(() => {
            lotes={activo:true,fechacompra:hoy,referencia:'',proveedor:'',observaciones:''};
            factura={total:0, cantidad:0, noverificarexistencias:false, carrito:[], pagado:false,formaPago:false,efectivo:'',efectivo_real:0,tarjeta:''};
        }, 300);
    }
   

    function uuidv4() {
        return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        ).toUpperCase();
    }

    let guardar=function() {

            let seleccionados = factura.carrito.filter(function(item){
                if (item.encontrado === false) {
                    return false;
                } else {
                    return true;
                }
            });

            postData($urlapi, [{'cmd':'lotes_insert','lote':lotes,'carrito':seleccionados,'user':{ 'iduser':$iduser }}])
            .then(data => {
                push('/lotes')
                //console.log(data[0])
            });
    }

    let actualizarTotales=function() {
        carritoObj.calcular();
        carritoObj.calcular_descuento();
    }

</script>

{#if viewPage===true}
<!-- <Navbar /> -->
<AnimationContainer container={false}>

    <div class="container-fluid bg-dark pt-1 pb-1">
        <div class='row'>
            <div class="col-12">
                
                <button disabled={!firma_disponible}  
                    class:btn-lg={$breakpoint === 'xxl'}
                    class:btn-md={$breakpoint !== 'xxl'}
                    on:click={guardar} type="button" class='btn btn-success me-3 '>
                    <i class="bi bi-receipt-cutoff me-1"></i>GUARDAR</button>

                <div class="float-end"
                    class:mt-1={$breakpoint !== 'xxl'}
                >
                    <Modal textButton='CANCELAR' functionSi={cancelarFactura}

                    classButton='btn-danger {($breakpoint === 'xxl')?"btn-lg":"btn-sm"}' iconButton='bi-x-square' title='ADVERTENCIA'>
                        Esta seguro que desea <strong>CANCELAR</strong>?<br/>
                        Se perderán los datos de la lote
                    </Modal>                    
                    <!-- <button type="button" on:click={cancelarFactura} class='btn btn-danger btn-sm me-1'><i class="bi bi-x-square me-1"></i>CANCELAR</button> -->
                    <button type="button"
                        class:btn-lg={$breakpoint === 'xxl'}
                        class:btn-sm={$breakpoint !== 'xxl'}
                        on:click={()=>push('/lotes')} class='btn btn-warning'><i class="bi bi-box-arrow-left me-1"></i>SALIR</button>
                </div>
            </div>
        </div>
    </div>

    <div class="container-fluid">
        <div class='row'>
            
            <div class="col-8">
                <Datoslote bind:lote={lotes}/>
            </div>
            <div class="col-4">
                <Totales bind:factura={factura}/>
            </div>

        </div>

        <div>
            <Carrito bind:factura={factura} bind:lote={lotes} bind:this={carritoObj} />
        </div>
    </div>

</AnimationContainer>    
{/if}